<template>
  <div class="txt-span">
    <div class="txt-item">
      <span
        v-for="(item,index) in navList"
        :key="index"
        :class="{active:index===currentAbout}"
        @click="goPage(item)"
      >{{item.label}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "txtnav",
  props: {
    navList: {
      type: Array
    }
  },
  data() {
    return {
      currentAbout: ""
    };
  },
  // 在组件的computed中使用全局state
  computed: {
    notioceState() {
      return this.$store.state.notioceState;
    },
    aboutState() {
      return this.$store.state.aboutState;
    }
  },
  watch: {
    notioceState(newName) {
      this.currentAbout = this.notioceState-1;
    },
    aboutState(newName) {
      this.currentAbout = this.aboutState;
    },
        $route: {
      handler(newRouter) {
        if (newRouter.name=="brief") {
        this.currentAbout = 0;
        }
      },
      immediate: true
    },
  },
  methods: {
    goPage(item) {
      this.currentAbout = item.type-1;
      this.$emit("goPage", item);
    }
  },
  created() {
    switch (this.$route.name) {
      case "jikeyun":
      case "brief":
        this.currentAbout = 0;
        break;
      case "hardsoft":
      case "Development":
        this.currentAbout = 1;
        break;
      case "sceneserve":
      case "culture":
        case "calculator":
        this.currentAbout = 2;
        break;
      case "honour":
        case "yunClass":
        case "yunClass-detail":
        this.currentAbout = 3;
        break;
      case "contact":
        this.currentAbout = 4;
        break;
      case "notice": {
       this.currentAbout = 3;
        break;
      }
      default:
        break;
    }
  }
};
</script>

<style lang="less" scoped>
.txt-span {
  width: 100%;
  height: 50px;
  background-color: rgba(246, 246, 246, 1);
  .txt-item {
    width: 1200px;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    span {
      cursor: pointer;
      // width: 82px;
      height: 50px;
      line-height: 50px;
      font-size: 16px;
      color: #666;
      margin-right: 36px;
    }
    span:hover,
    .active {
      font-size: 16px;
      color: rgba(84, 133, 232, 1);
      border-bottom: solid 2px rgba(84, 133, 232, 1);
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/txt-nav.vue